import ColorPickerItem from "./ColorPickerItem";
import ClickAwayListener from "react-click-away-listener";

const ColorPicker = ({
  title,
  colors,
  show,
  setShowColorPicker,
  setNewColor,
}: any) => {
  const handleNewColor = (color: any) => {
    setNewColor(color);
  };

  if (!show) return <></>;

  return (
    <ClickAwayListener onClickAway={() => setShowColorPicker(false)}>
      <div className="absolute z-10 max-sm:right-[38%] lg:left-[100%] md:right-[100%]  top-[-50%] bg-white shadow-card w-[320px] rounded-lg">
        <div className="flex justify-between items-center bg-darknavy text-white py-2 px-4 rounded-t-lg">
          <div className="font-bold text-lg">{title}</div>
          <div
            className="font-bold text-lg cursor-pointer text-lightgrey hover:text-white"
            onClick={() => setShowColorPicker(false)}
          >
            X
          </div>
        </div>
        <div className="flex flex-wrap gap-2 py-3 px-4">
          {colors.map((color: string, index: string) => (
            <ColorPickerItem
              key={index}
              colorHex={color}
              handleNewColor={handleNewColor}
            />
          ))}
        </div>
      </div>
    </ClickAwayListener>
  );
};
export default ColorPicker;
